import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Container } from "./CommonStyles";
import { MultiSelectHoriz, MultiSelectHorizProps } from "../form/multi-select-horiz/MultiSelectHoriz";
import { LabelledValue } from "@kaltura/mediaspace-shared-types";

export interface MultiSelectHorizFieldProps extends Omit<MultiSelectHorizProps, "value" | "onChange"> {
    value?: LabelledValue[];
    inline?: boolean;
}

/**
 * multi-select checkbox field
 */
export const MultiSelectHorizField = forwardRef<any, MultiSelectHorizFieldProps>(
    (props: MultiSelectHorizFieldProps, ref) => {
        const { inline, ...passThroughProps } = props;
        const { control } = useFormContext();

        return (
            <Container inline={inline}>
                <Controller
                    control={control}
                    name={props.id as "dummy"}
                    defaultValue={props.value || []}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <MultiSelectHoriz {...passThroughProps} value={value} onChange={onChange} onBlur={onBlur} />
                    )}
                />
            </Container>
        );
    }
);
